// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"attachment-list"},"nodeName":"g","children":[{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M20 9H23M18 14H23M15 19H23","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M14.1932 13.6692L9.1821 18.6146C8.05175 19.7302 6.43112 20.2159 4.86287 19.9103C2.95527 19.5384 1.4633 18.0649 1.08943 16.1817C0.783195 14.6391 1.27403 13.0472 2.39899 11.9345L9.47155 4.93867C10.0901 4.32683 10.9333 3.98831 11.809 4.00031L11.8859 4.00136C13.573 4.02447 14.9436 5.35236 14.9983 7.01668C15.0266 7.87791 14.6924 8.71228 14.075 9.32157L6.99915 16.3047C6.75767 16.5431 6.44463 16.698 6.10667 16.7465C5.05088 16.898 4.14813 15.9974 4.31307 14.9571L4.31924 14.9182C4.37209 14.5848 4.53084 14.2767 4.77258 14.0381L11.1853 7.70926","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-attachment-list')
export default class AttachmentListIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'attachment-list',
    }
  }
}
